// session-storage.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionStorageService {
  private storageSubject = new BehaviorSubject<{ key: string; value: any } | null>(null);

  // Observable you can subscribe to
  storage$ = this.storageSubject.asObservable();

  setItem(key: string, value: any): void {
    sessionStorage.setItem(key, JSON.stringify(value));
    this.storageSubject.next({ key, value });
  }

  getItem<T>(key: string): T | null {
    const data = sessionStorage.getItem(key);
    return data ? (JSON.parse(data) as T) : null;
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
    this.storageSubject.next({ key, value: null });
  }

  clear(): void {
    sessionStorage.clear();
    this.storageSubject.next({ key: 'all', value: null });
  }
}
